import { createFileRoute, redirect } from '@tanstack/react-router';

// Budget management moved to Business > Budget (#4683). Keep this route as a
// permanent redirect so stale bookmarks/links land on the budget tab instead
// of a 404.
export const Route = createFileRoute('/_authenticated/_layout/settings/_layout/budget')({
  beforeLoad: () => {
    throw redirect({ to: '/business' as string, hash: 'budget' });
  },
});
